import { H2 } from "components/atoms/H2";
import dynamic from "next/dynamic";
import { Review } from "shared/types";

const ReviewCard = dynamic(
  async () =>
    (await import("shared/components/molecules/ReviewCard")).ReviewCard
);

interface Props {
  reviews: Review[] | undefined;
  goToReviews?: () => void;
  className?: string;
}

export const ReviewList = ({ reviews, goToReviews, className }: Props) => {
  const hasReviews = reviews?.length > 0;
  return (
    <div className={className}>
      <H2 readMore={hasReviews && !!goToReviews} onClick={goToReviews}>
        みんなの感想・レビュー
      </H2>
      <div tw="mt-6">
        {reviews?.map((review: Review) => (
          <ReviewCard key={review.id} tw="mt-6" review={review} />
        ))}
        {!hasReviews && (
          <p tw="font-base font-normal text-2xs leading-5 tracking-[.29px]">
            まだみんなの感想・レビューは投稿されていません
          </p>
        )}
      </div>
    </div>
  );
};
